export default __webpack_public_path__ + "static/media/scattered_piece_of_decarabians_dream.ff290e8f.png";